// extracted by mini-css-extract-plugin
export default {"Container":"payroll_Container__1vgjS","section-1":"payroll_section-1__EiuE1","content":"payroll_content__tB2rG","section-2":"payroll_section-2__1J-mR"};